export const _ON_CHANGE_SEARCH = '_ON_CHANGE_SEARCH'
export const _CLEAR_SEARCH = '_CLEAR_SEARCH'
